import React from "react";
import logo from "../../../../../assets/logo.png";
import { useTranslation } from "react-i18next";

export const AffiliatesJoinIntroStep = ({
  handleGoToNextSlide,
}: {
  handleGoToNextSlide: () => void;
}) => {
  const { i18n, t } = useTranslation(["affiliates"]);
  const isRTL = i18n.dir() === "rtl";

  return (
    <div className="join-affiliates-popup-content-wrapper">
      <div className="join-affiliates-popup-content-container">
        <img
          src={logo}
          style={{
            width: "97px",
            height: "60px",
          }}
        />
        <div
          className="join-affiliates-popup-title"
          style={{
            fontFamily: isRTL ? "Noto Sans Hebrew" : "Frank Ruhl Libre",
          }}
        >
          {t("make_money_while_you_share")}
        </div>
        <div className="join-affiliates-popup-desc">
          {t("make_money_while_you_share_desc")}
        </div>
        <div className="continue-btn" onClick={handleGoToNextSlide}>
          {t("continue")}
        </div>
      </div>
    </div>
  );
};
